// extracted by mini-css-extract-plugin
export default {"link":"Integrity_link__MPZZa"};